/* eslint-disable @typescript-eslint/default-param-last */
import { GET_COMPANY } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { ICompanyActionType } from '../types/company.types';

const companyReducer = (
  state = initialState.company,
  action: ICompanyActionType
) => {
  switch (action.type) {
    case `${GET_COMPANY}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default companyReducer;
